import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen
} from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  tariffGetList,
  tariffAdd,
  tariffGetTypes
} from "actions/tariff/actions";

import EditModal from "views/pages/tariff/edit-modal";

const Tariff = ({
                  tariffGetTypes,
                  tariffTypes,
                  tariffList,
                  tariffGetList,
                  tariffAdd,
                  ...props
                }) => {
  useEffect(() => {
    tariffGetList();
    tariffGetTypes();
  }, [tariffGetList, tariffGetTypes]);

  const modalEdit = (tariff = false) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: tariff ? "Edit tariff" : "Create New Tariff",
      children: (
        <EditModal
          tariff={tariff}
          types={tariffTypes}
          onCancel={() => props.closeCustomModal(modalObj)}
          onSubmit={(data) => {
            tariffAdd(data);
            props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => props.closeCustomModal(modalObj)
    };
    props.openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Activable",
      accessor: "activable",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.activable ? "text-success" : "text-danger"}>
          {original.activable ? "Yes" : "No"}
        </div>
      )
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Order",
      accessor: "order",
    },
    {
      Header: "Price",
      accessor: "pricing",
    },
    {
      id: "actions",
      Header: "Actions",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className="d-flex justify-content-around">
          <button
            className="btn btn-sm btn-primary"
            onClick={() => modalEdit(original)}
          >
            <FontAwesomeIcon icon={faPen}/>
          </button>
        </div>
      ),
      headerClassName: "text-center",
      className: "text-center"
    }
  ];

  return (
    <div className="w-100 p-2">
      <div className="d-flex justify-content-between filters">
        <h3>Tariff</h3>
        <div>
          <button
            className="btn btn-sm btn-success"
            onClick={() => modalEdit()}
          >
            Create New Tariff
          </button>
        </div>
      </div>

      <ReactTable
        data={tariffList}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight"
        loading={false}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        getNoDataProps={() => ({
          style: {
            zIndex: 0
          }
        })}
        style={{
          height: "calc(100vh - 110px)"
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  tariffList: state.tariff.tariffList,
  tariffTypes: state.tariff.types,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  tariffGetList: bindActionCreators(tariffGetList, dispatch),
  tariffAdd: bindActionCreators(tariffAdd, dispatch),
  tariffGetTypes: bindActionCreators(tariffGetTypes, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Tariff);



// WEBPACK FOOTER //
// ./src/views/pages/tariff/list.js